import { Box } from "@mui/material";

export const Line = ({ children, height, sx }) => (
  <Box
    sx={{
      width: 52,
      display: "flex",
      justifyContent: "center",
      ...sx,
    }}
  >
    <Box
      sx={{
        width: 0,
        ...(height && { height }),
        border: "solid 0.5px #C2C2C2",
        position: "relative",
      }}
    >
      {children}
    </Box>
  </Box>
);

export const PointerLine = ({ top = "50%" }) => (
  <Box
    sx={{
      width: 20,
      height: 0,
      border: "solid 0.5px #C2C2C2",
      position: "absolute",
      top,
      bottom: "50%",
      left: -0.5,
      "&:after": {
        content: '""',
        width: "5px",
        height: "5px",
        borderRadius: "50%",
        backgroundColor: "#C2C2C2",
        position: "absolute",
        right: -2.5,
        top: -2.5,
      },
    }}
  ></Box>
);
export const JoinLine = () => (
  <Line>
    <PointerLine />
  </Line>
);

export const CornerLine = () => (
  <Line height="50%">
    <PointerLine top="100%" />
  </Line>
);

export const Column = ({ length }) => (
  <Box sx={{ display: "grid" }}>
    {Array.from({ length }, (_, i) => i + 1).map((i) => (
      <Box sx={{ display: "flex" }} key={i}>
        {i !== length ? <JoinLine /> : <CornerLine />}
      </Box>
    ))}
  </Box>
);
